import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

export const LinkLoader = () => {
    const { gray100 } = colors;

    return (
        <Skeleton
            variant="rectangular"
            width={156}
            height={40}
            css={css({
                background: gray100,
                borderRadius: "10px"
            })}
        />
    );
};
